import React, { useState ,useRef} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import DateUtil from 'utils/DateUtil';


function ContentsContainer() {

	let quaTskPopData = {};          //과제 찾기 팝업

	const modaladm1601p = useToggleState({});
	const modaladm1602p = useToggleState({});		

	const [modaladm1601Open, setModaladm1601Open] = useState(false); //
	const [modaladm1600Open, setModaladm1600Open] = useState(false); //과제선택 팝업오픈여부
	

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count
 
	/** 검색조건 */
	const [searchText,setSearchText] = useState('');
	const [searchDivCd,setSearchDivCd] = useState('01');

	//초기 데이터 설정
	let MainSheetData = {};
	let CreateSheetData = {};

	const [StartDate, setStartDate] = useState(() => {
	const currentYear = new Date().getFullYear();
		return new Date(currentYear, 0, 1);
	});

	const [dateNum,setDateNum] = useState(0); //날짜 기본값	
	const [EndDate, setEndDate] = useState(new Date());
	
	const [searchIndicators, setSearchIndicators] = useState('');

	//검색조건 저장용
	let searchParams = useRef<any>({});
	let pageNum = useRef<number>(1);
	let searchType = useRef<String>('');

	/**ibsheet 세팅  */
	//초기 데이터 설정
	let totalCnt = useRef<number>(0);
	let defaultRowCnt = 20;
	let rowCnt = useRef<number>(20);

	let totalQuaTskCnt = useRef<number>(0);
	let rowQuaTskCnt = useRef<number>(20);
	const [totalQuaTskRowCnt,setTotalQuaTskRowCnt] = useState(0);

	const [pop2ShowYn, setPop2ShowYn] = useState('');
	const [pop2QuaType, setPop2QuaType] = useState('');
	const [pop2QuaText, setPop2QuaText] = useState('');
	const [pop2QuaId, setPop2QuaId] = useState('');

	const [searchTskNm,setSearchTskNm] = useState('');
	const [searchTskReqNo,setSearchTskReqNo] = useState('');
	const [searchStartDate,setSearchStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [searchEndDate,setSearchEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [searchQuaId, setSearchQuaId] = useState('');

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": showRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 0
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
			{"Header": "No","Name": "SEQ","Width": "90"},
			
			],
			"Cols": [
				{"Header": "No","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
				{"Header": { "Value": "", "HeaderCheck": 1,  "IconAlign": "Center"	},"Type": "Bool","Name": "chk","Width": 80,"Align": "Center",	"CanEdit": 1 },
				{"Header": "출력여부","Type": "Enum","Name": "SHOW_YN","RelWidth": 1,"Align": "Center","CanEdit": 0,"Enum": "|출력|미출력","EnumKeys": "|Y|N"},
				{"Header": "정성/정량","Type": "Enum","Name": "QUA_TYPE","RelWidth": 1,"Align": "Center","CanEdit": 0,"Enum": "|정성|정량","EnumKeys": "|EXE|QUE"},
				{"Header": "지표목","Type": "Text","Name": "QUA_TEXT","TextStyle": 4,"MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 2},
				{"Header": "지표등록건수","Type": "Text","Name": "QUA_REG_CNT","TextStyle": 4,"MinWidth": 60,"Align": "Center","CanEdit": 0,"RelWidth": 1},
				{"Header": "등록일","Type": "Text","Name": "CREAT_DT","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1 }
				
			]
				 
		},

		'indicatorsInit':{
			"Def": {
				"Row": {
				"CanFormula": true
				}
			},
			"Cfg": {
				"SearchMode": 3,
				//"PageLength": 20,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 0,
				"ZIndex": "999",
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
			{"Header": "NO","Name": "SEQ","Width": "90"},
			
			],
			"Cols": [
				{"Header": "NO","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
				{"Header": { "Value": "", "HeaderCheck": 1, "IconAlign": "Center"},"Type": "Bool","Name": "chk","Width": 80,"Align": "Center","CanEdit": 1 },
				{"Header": "출력여부","Type": "Enum","Name": "SHOW_YN","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|출력|미출력","EnumKeys": "|Y|N"},
				{"Header": "정성/정량","Type": "Enum","Name": "QUA_TYPE","RelWidth": 1,"Align": "Center","CanEdit": 1,"Enum": "|정성|정량","EnumKeys": "|EXE|QUE"},
				{"Header": "지표목","Type": "Text","Name": "QUA_TEXT","Align": "Center","CanEdit": 1,"RelWidth": 2}
			]
				 
		},


		"QuaTskList": {  //지급과제조회
			"Cfg": {
				"SearchMode": 3,
				//"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate": "0"
			},
			"Cols": [
				{"Header": "No","Type": "Int", "Name": "","Align": "Center","RelWidth": 1},
				{"Header": "과제신청번호","Type": "Text","Name": "TSK_REQ_NO","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1 ,"CustomFormat": "#-##-#####"},
				{"Header": "과제명","Type": "Text","Name": "TSK_NM","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1 },
				{"Header": "과제신청일자","Type": "Date","Name": "TSK_REQ_DATE","RelWidth": 1.5,"Align": "Center","CanEdit": "0", Format: "yyyy-MM-dd", DataFormat: "yyyy-MM-dd"},
				{"Header": "기대효과","Type": "Text","Name": "QUA_TEXT","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1 },
				{"Header": "지표목입력내역","Type": "Text","Name": "QUA_VALUE","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1 },
				{"Header": "과제종결여부","Type": "Text","Name": "TSK_CLO_YN","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1 }
			]

		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				var sheet = evtParam.sheet;
				//초기 데이터 로딩
				if(sheet.id == 'sheet'){
					doSearch('search');  //왼쪽탭 전체목록
				
				}
					
			},
			//시트 클릭시 이벤트 처리
			onAfterClick:function(evtParam){
				if(evtParam.kind != "Header"){
					var sheet = evtParam.sheet;
					
					//지표목 수정처리
					if(sheet.id =='sheet'){

						if(evtParam.col == "QUA_TEXT" ){
							var row = sheet.getFocusedRow();
							
							let showYn = row["SHOW_YN"];
							let quaType = row["QUA_TYPE"];
							let quaText = row["QUA_TEXT"];
							let quaId = row["QUA_ID"];
							setPop2ShowYn(showYn);
							setPop2QuaType(quaType);
							setPop2QuaText(quaText);
							setPop2QuaId(quaId);

							modaladm1602p.open();
						} else if(evtParam.col == "QUA_REG_CNT" ){   //지표목 입력리스트 보기 
							var row = sheet.getFocusedRow();
							let quaId = row["QUA_ID"];
							setSearchQuaId(quaId);

							modal1600Open();
						}
					}
				}

		    },	
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;
		
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
				_data = JSON.stringify(d.slice(0, 20), null, 2);
				_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
				_data = JSON.stringify(d, null, 2);
				}
				
			},
			onAfterGotoPage:function (evtParam) {
				
				var sheet = evtParam.sheet;
				if(sheet.id =='sheet'){
					var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
		
					pageNum.current = page; //페이지 번호 저장용 

					//@ts-ignore
					if (currentPage != -1 && currentPage != page) {
						makePageIndex(page);
					}
				}
				
			}
		},

		'indicatorsEvents':{
			onRenderFirstFinish:function (evtParam) {
				var sheet = evtParam.sheet;
				
				//@ts-ignore
				sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
				
				rowAdd();	
			},

		},

		'quaTskEvent':{
			onRenderFirstFinish:function (evtParam) {
				var sheet = evtParam.sheet;
				
				getQuaTskList('init');  //왼쪽탭 전체목록
				//@ts-ignore
				IBSheet.QuaTskList.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
				
			},

		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'MainSheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//조회 데이터
		'data':[],

		//시트객체 생성
		'indicatorsCreate':function () {
			let options = this.indicatorsInit;
			//@ts-ignore
			options.Events = this.indicatorsEvents;
			//@ts-ignore
			IBSheet.create({
				id: 'indicators', // 생성할 시트의 id
				el: 'indicatorsDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.indicatorsData // 생성될 시트의 정적데이터
			});
		},

		//시트객체 생성 : 지표목 입력 리스트 
		'createQuaTskList':function () {
			var options2 = this.QuaTskList;
			options2.Events = this.quaTskEvent;
			//@ts-ignore
			IBSheet.create({
				id: 'QuaTskList', // 생성할 시트의 id
				el: 'QuaTskListDiv', // 시트를 생성할 Dom 객체 및 id
				options: options2, // 생성될 시트의 속성
				data: quaTskPopData // 생성될 시트의 정적데이터
			});

			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},

		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "성과관리_"+today+".xlsx"});
		},
		//엑셀 다운로드
		'exportQuaTskData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.QuaTskList.down2Excel({fileName: "지표목입력리스트_"+today+".xlsx"});
		},

		//조회 데이터
		'indicatorsData':[],
		'quaTskPopData':[]
		
	}

	
	//====== 그리드 공통 부  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}
	
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
			// @ts-ignore
			document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}
	
			// @ts-ignore
			currentPage = tp;
			// 디비전체 데이터 건수를 알아야 한다. 조회 데이터구성 할때 etc 데이터에 TotalRow로 전체 데이터 건수를 가져 온다.
			// @ts-ignore
			var sr = sheet.getTotalRowCount(); // 전체 조회 건수
			// @ts-ignore
			var page = sheet.PageLength; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';
	
			let k = 1;
	
			if (thispage !== 1) {
			let ul_sub = document.createElement('DIV');
			ul_sub.className ="group";
			li = document.createElement('Button');
			li.className = 'item first';
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			tt = document.createTextNode('<<');
			addEventHandler(li, 'click', pageMove, 1);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub.appendChild(li)
			ul.appendChild(ul_sub);
			
			li = document.createElement('Button');
			li.className = 'item prev';
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			addEventHandler(li, 'click', pageMove, tp - 1);
			tt = document.createTextNode('<');
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub.appendChild(li)
			ul.appendChild(ul_sub);
			}
	
			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
			if (i <= lastpage) {
				li = document.createElement('Button');
				li.className ="item";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode(String(i));
				addEventHandler(li, 'click', pageMove, i);
				if (i === tp) {
				li.className ="item active";
				}
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub2.appendChild(li);
				ul.appendChild(ul_sub2);
			}
			}
	
			if (thispage < lastpage) {
			let ul_sub3 = document.createElement('DIV');
			ul_sub3.className ="group";	
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			li = document.createElement('Button');
			li.className = 'item next';
			tt = document.createTextNode('>');
			addEventHandler(li, 'click', pageMove, tp + 1);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub3.appendChild(li);
			ul.appendChild(ul_sub3);
			
			li = document.createElement('Button');
			li.className = 'item last';
			tt = document.createTextNode('>>');
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			addEventHandler(li, 'click', pageMove, lastpage);
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub3.appendChild(li);
			ul.appendChild(ul_sub3);
			}
	
			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			console.log(ex.message);
		}
		}
		
		//페이지 이동
		// @ts-ignore
		const pageMove = function (cPage:number) {
			// @ts-ignore
			sheet.goToPageByIndex(cPage);
		}
		
		//페이지 이동 이벤트 핸들러
		// @ts-ignore
		const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
		}
	

	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string) {
		let sDt = DateUtil.toDateFormat(StartDate, "YYYY-MM-DD");
		let eDt = DateUtil.toDateFormat(EndDate, "YYYY-MM-DD");
		
		let param = {
			"QUA_TEXT": searchIndicators,
			"WRITE_ST_DT" : sDt,
			"WRITE_ED_DT" : eDt
		};
	
		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_1600_selectList',
			data: param
		})

		//전체데이터 
		let result = response.LIST;

		if(result != null){
			//전체ROW개수 
			totalCnt.current = Object.keys(result).length;
			setTotalRowCnt(Object.keys(result).length);
		}
		
	   //데이터 처리
	   ib.data = result;
	   // @ts-ignore	
	   sheet.loadSearchData(result);  //data 로딩 처리 
	   // @ts-ignore	
	   sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	   // @ts-ignore	
	   makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
		
    }
	//====== 그리드 데이터 가지고 오기  END

    //지표목 건수 조회
	async function getQuaTskList(sAction:string) {
		let param = {};
		let sDt = DateUtil.toDateFormat(searchStartDate, "YYYY-MM-DD");
		let eDt = DateUtil.toDateFormat(searchEndDate, "YYYY-MM-DD");
	
		//if(sAction =='search'){
			param = {
				"TSK_NM" : searchTskNm.toUpperCase(),
				"TSK_REQ_NO" : searchTskReqNo.toUpperCase(),
				"QUA_ID": searchQuaId,
				"WRITE_ST_DT" : sDt,
				"WRITE_ED_DT" : eDt
			};
		//}

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_1601_selectList',
			data: param
		})

		//전체데이터 

		let result = response.LIST

		if(result != null){
			//전체ROW개수 
			totalQuaTskCnt.current = Object.keys(result).length;
			setTotalQuaTskRowCnt(Object.keys(result).length);
		}
		
	   //데이터 처리
	   ib.quaTskPopData = result;
	   // @ts-ignore	
	   QuaTskList.loadSearchData(result);  //data 로딩 처리 
	   // @ts-ignore	
	   QuaTskList.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	   // @ts-ignore	
	  // makePageIndex(QuaTskList.getPageIndex( QuaTskList.getFocusedPage()) + 1); // 페이지 초기화
		
    }

	//행 추가
	const rowAdd = () => {
		//@ts-ignore
		indicators.addRow( {"next":indicators.getFirstRow()} )
		
		//@ts-ignore
		indicators.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		
	} 

	// 행 삭제
	const rowDel = () => {
        //@ts-ignore
		indicators.deleteRow(indicators.getFocusedRow(), 1, 0, 0);

		//@ts-ignore
		indicators.rerender(1); //최종 수정된 내용을 화면에 반영한다.
		
	} 

	async function SetDate(value){
	    const newEndDate = new Date();
	    setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
	    const newStartDate = new Date(newEndDate);
	    newStartDate.setDate(newEndDate.getDate() - value);
	    setStartDate(newStartDate);  // 시작 날짜를 조정
    }

	// 지표목등록 모달 modal1601Open 오픈
	async function modal1601Open() {
		// @ts-ignore
		if(IBSheet.indicators !==undefined){
			// @ts-ignore
			IBSheet.indicators.dispose();
		}
		
		setModaladm1601Open(true)
	}
	
	//지표목등록 modaladm1601Close 닫기
	async function modaladm1601Close() {
		// @ts-ignore
		if(IBSheet.indicators !==undefined){
			// @ts-ignore
			IBSheet.indicators.dispose();
		}
		setModaladm1601Open(false);
	}

	//지표목등록 IBSheet오픈 
	async function onAfterModaladm1601Open() {
		// @ts-ignore
		if(IBSheet.indicators !==undefined){
			// @ts-ignore
			IBSheet.indicators.dispose();
		}
		ib.indicatorsCreate();
    }
	
	//지표목 수정
	async function modaladm1602pSave(){
		if (await UIUtils.confirm("수정하시겠습니까?")) {
			let params = {
				"SHOW_YN" : pop2ShowYn
				,"QUA_TYPE":pop2QuaType
				,"QUA_TEXT":pop2QuaText
				,"QUA_ID":pop2QuaId
			}
			
			const response:any = await CommonUtil.execute({
				url:"adm_1600_update",
				data: params
			}).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});

			if (response) {
				UIUtils.alert("처리되었습니다.").then(()=>{
					doSearch('search');
					
					modaladm1602p.close();
				});
			}
		}
	}


	async function getQuaTskAllList(sAction:string) {
		let param = {};
		let sDt = DateUtil.toDateFormat(searchStartDate, "YYYY-MM-DD");
		let eDt = DateUtil.toDateFormat(searchEndDate, "YYYY-MM-DD");
	
		//if(sAction =='search'){
			param = {
				"TSK_NM" : searchTskNm.toUpperCase(),
				"TSK_REQ_NO" : searchTskReqNo.toUpperCase(),
				"QUA_ID": searchQuaId,
				"WRITE_ST_DT" : sDt,
				"WRITE_ED_DT" : eDt
			};
		//}

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'adm_1601_selectList',
			data: param
		})

		//전체데이터 

		let result = response.LIST

		if(result != null){
			//전체ROW개수 
			totalQuaTskCnt.current = Object.keys(result).length;
			setTotalQuaTskRowCnt(Object.keys(result).length);
		}
		
	   //데이터 처리
	   ib.quaTskPopData = result;
	   // @ts-ignore	
	   QuaTskList.loadSearchData(result);  //data 로딩 처리 
	   // @ts-ignore	
	   QuaTskList.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	   // @ts-ignore	
	  // makePageIndex(QuaTskList.getPageIndex( QuaTskList.getFocusedPage()) + 1); // 페이지 초기화
		
    }

	//지표목 삭제
	async function quaDeleteList(){
		var count = 0;
		// @ts-ignore
		var rows = sheet.getDataRows();
		
		for (var i = 0; i < rows.length; i++) {
			if(rows[i]["chk"] != undefined){
				if ( rows[i]["chk"] ===  1){	
					count++;
				}
			}
		}
		
		if( count === 0 ){
			UIUtils.alert('삭제할 항목을 선택하세요.').then();
			return;
		}
		
		var delItems: { QUA_ID: string; }[] = [];
		// @ts-ignore
		var delItem:  { QUA_ID: string; } = {};
		
		for (var i = 0; i < rows.length; i++) {
			if ( rows[i]["chk"] ===  1){
				delItem = {
					QUA_ID: rows[i]["QUA_ID"],
				}
				delItems.push(delItem);
			}
		}
		//console.log("apprItems :" + delItems.length +" / " + JSON.stringify(delItems));

		if (await UIUtils.confirm("삭제하시겠습니까?")) {
			let params = {
				"CHECK_DEL_LIST" : delItems
			}
			
			const response:any = await CommonUtil.execute({
				url:"adm_1600_deleteList",
				data: params
			}).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});

			if (response) {
				UIUtils.alert("처리되었습니다.").then(()=>{
					doSearch('search');

					modaladm1601Close();
				});
			}
		}
    }

	//지표목 등록 저장 
	async function modaladm1601Save(){
		var count = 0;
		// @ts-ignore
		var rows = indicators.getDataRows();
		
		for (var i = 0; i < rows.length; i++) {
			if(rows[i]["chk"] != undefined){
				if ( rows[i]["chk"] ===  1){	
					count++;
				}
			}
		}
		
		if( count === 0 ){
			UIUtils.alert('저장할 항목을 선택하세요.').then();
			return;
		}
		
		
		var addItems: { SHOW_YN: string;QUA_TYPE:string;QUA_TEXT:string }[] = [];
		// @ts-ignore
		var addItem:  { SHOW_YN: string;QUA_TYPE:string;QUA_TEXT:string  } = {};
		
		for (var i = 0; i < rows.length; i++) {
			if ( rows[i]["chk"] ===  1){

				if(rows[i]["SHOW_YN"] == ''){
					UIUtils.alert('출력여부를 선택해 주세요.').then();
					return;
				}

				if(rows[i]["QUA_TYPE"] == ''){
					UIUtils.alert('정성/정량 선택해 주세요.').then();
					return;
				}

				if(rows[i]["QUA_TEXT"] == ''){
					UIUtils.alert('지표목을 입력해 주세요.').then();
					return;
				}

				addItem = {
					 SHOW_YN :rows[i]["SHOW_YN"]
					,QUA_TYPE:rows[i]["QUA_TYPE"]
					,QUA_TEXT:rows[i]["QUA_TEXT"]
				}
				addItems.push(addItem);
			}
		}
		//console.log("apprItems :" + addItems.length +" / " + JSON.stringify(addItems));

		
		if (await UIUtils.confirm("저장하시겠습니까?")) {
			let params = {
				"CHECK_INSERT_LIST" : addItems
			}
			
			const response:any = await CommonUtil.execute({
				url:"adm_1600_insert",
				data: params
			}).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});

			if (response) {
				UIUtils.alert("처리되었습니다.").then(()=>{
					doSearch('search');

					modaladm1601Close();
				});
			}
		}
	}

	//페이지 건수별로 보기 
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){
			searchType.current = 'M';
			rowCnt.current = e.target.value;
			setShowRowCnt(rowCnt.current);
			//receivedData.searchPageRowCnt = rowCnt.current;
			
			// @ts-ignore
			IBSheet.disposeAll(true);		  
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();
			
		 }
		 
	};

	//인풋 엔터체크
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			doSearch('search');
		}
	}

	//인풋 엔터체크
	const activeQuaTskEnter = (e) => {
		if(e.key === "Enter") {
			getQuaTskList('search');
		}
	}

	// 성과관리 지표등록건수 전체건수 다운로드 모달 modal2135Open 오픈
	async function modal1600AllOpen() {
		setSearchQuaId('');
		setSearchTskNm('');
		setSearchTskReqNo('');
		
		// @ts-ignore
		if(IBSheet.QuaTskList !==undefined){
			// @ts-ignore
			IBSheet.QuaTskList.dispose();
		}
		setModaladm1600Open(true)
	}

	// 성과관리 지표등록건수 모달 modal2135Open 오픈
	async function modal1600Open() {
		// @ts-ignore
		if(IBSheet.QuaTskList !==undefined){
			// @ts-ignore
			IBSheet.QuaTskList.dispose();
		}
		setModaladm1600Open(true)
	}

	//성과관리 지표등록건수 모달 modaladm1600Close 닫기
	async function modaladm1600Close() {
		// @ts-ignore
		if(IBSheet.QuaTskList !==undefined){
			// @ts-ignore
			IBSheet.QuaTskList.dispose();
		}
		setModaladm1600Open(false);
	}

	//성과관리 지표등록건수 모달 onAfterModaladm6616 IBSheet오픈 
	async function onAfterModaladm1600Open() {
		// @ts-ignore
		if(IBSheet.QuaTskList !== undefined){
			// @ts-ignore
			IBSheet.QuaTskList.dispose();
		}
		ib.createQuaTskList();
    }


	 // init 
	 React.useEffect(() => {
    
		 //ib시트 생성
		ib.create();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);		  
		  }
		
    },[])

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={5}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">성과관리</h1>

					<div className="sf sf-1row sf-3col mb30"> 
						<div className="inner">
							<div className="sf-item sf-m-1-3">
								<p className="sf-key">등록일자</p>
								<div className="sf-value">
									<div className="fund-datepicker">
										<div className="hz-root hz-gap5">
											<UIDatePicker className="hz-item" value={StartDate} valueChanged={(value) => setStartDate(value)}/>
											<span className="hz-item">~</span>
											<UIDatePicker className="hz-item" value={EndDate} valueChanged={(value) => setEndDate(value)}/>
										</div>
										<div className="hz-item hz-root hz-gap5">		
										<Button color={dateNum == 1 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(1); setDateNum(1); }}>당일</Button>
										<Button color={dateNum == 2 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(30); setDateNum(2); }}>이전 1개월</Button>
										<Button color={dateNum == 3 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(180); setDateNum(3); }}>이전 6개월</Button>
										<Button color={dateNum == 4 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(360); setDateNum(4); }}>이전 12개월</Button>
										</div>
									</div>
								</div>
								
							</div>
							<div className="sf-item">
								<p className="sf-key">지표목</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={searchIndicators} valueChanged={(value) => setSearchIndicators(value)} placeholder={'지표목을 입력하세요'} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>							
						</div>
						<button className="bt" data-color="pri" data-size="md"  type="button" onClick={()=> doSearch('search')}>조회</button> 
					</div>

					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="gray-o" size="sm" onClick={modal1600AllOpen}>지표목 다운로드</Button>
							<Button color="gray-o" size="sm" onClick={quaDeleteList}>지표목 삭제</Button>
							 <Button color="pri-o" size="sm" onClick={modal1601Open}>지표목 등록</Button>
							<div className="sl sl-sm w120">
							<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>

					<div className="ibsheet" id='MainSheetDiv'></div>
					<div id="pageNavi" className="pg"></div>			

				</main>
			</div>

		{/* modal - 1601p*/}
		<ModalPopup
				open={modaladm1601Open}
				title="지표목 등록"
				size="lg"
				onClose={() => modaladm1601Close()}
				onAfterOpen={() => onAfterModaladm1601Open()}
			>
				<div className="modal-con">
					<div className="tb-top">
						<div className="hz-root hz-right hz-gap5 w100p">
							<Button color="pri-o" size="sm" onClick={rowAdd}>행추가</Button>
							<Button color="gray-o" size="sm" onClick={rowDel}>행삭제</Button>
						</div>
					</div>

					<div id='indicatorsDiv' style={{height:'500px'}}></div>

				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={modaladm1601Close}>취소</Button>
						<Button color='pri' size="md" onClick={modaladm1601Save}>저장</Button>
					</div>
				</div>	
			</ModalPopup>


			{/* modal - 6613 */}	
			<ModalPopup
				open={modaladm1602p.isShowing}
				title="지표목 수정"
				size="sm"
				onClose={modaladm1602p.close}
			>
				<div className="modal-con">
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">출력</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<select value={pop2ShowYn} onChange={(e) => setPop2ShowYn(e.target.value)}>
											<option value="Y">출력</option>
											<option value="N">미출력</option>
										</select>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">정성/정량</p>
								<div className="fo-value">
								<div className="sl sl-md w100p">
										<select value={pop2QuaType} onChange={(e) => setPop2QuaType(e.target.value)}>
											<option value="EXE">정성</option>
											<option value="QUE">정량</option>
										</select>
									</div>									
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">지표목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={pop2QuaText} valueChanged={(value) => setPop2QuaText(value)}  />
								</div>
							</div>
							
						</div>
					</form>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={modaladm1602p.close}>취소</Button>
						<Button color='pri' size="md" onClick={modaladm1602pSave}>저장</Button>
					</div>
				</div>	
			</ModalPopup>



			{/* modal - 성과관리 과제신청 리스트 */}
			<ModalPopup
				open={modaladm1600Open}
				title="지표목입력 리스트"
				size="xlg"
				onClose={() => modaladm1600Close()}
				onAfterOpen={() => onAfterModaladm1600Open()}
			 >
				<div className="modal-con">
					<div className="modal-tskana">
					<div className="fo fo-col2 mb15">
							<div className="inner">
								<div className="fo-item fo-item fo-m-1-3">
									<p className="fo-key">과제신청일자</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
										   <UIDatePicker className="hz-item" value={searchStartDate}
														  valueChanged={(value) => setSearchStartDate(value)}/>
											<span className="hz-item">~</span>
											<UIDatePicker className="hz-item" value={searchEndDate}
														  valueChanged={(value) => setSearchEndDate(value)}/>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={searchTskReqNo} valueChanged={(value) => setSearchTskReqNo(value)}	 placeholder={'과제번호를 입력하세요.'} onKeyEnter={(e) => activeQuaTskEnter(e)}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={searchTskNm} valueChanged={(value) => setSearchTskNm(value)} placeholder={'과제명을 입력하세요.'} onKeyEnter={(e) => activeQuaTskEnter(e)}/>
									</div>
								</div>
							</div>
						</div>

						<div className="hz-root hz-center mb30">
							<Button color="pri" size="md" onClick={()=>getQuaTskList('search')}>조회</Button>
						</div>
						<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalQuaTskRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="gray-o" size="sm" id="goDown" onClick={()=> ib.exportQuaTskData()}>다운로드</Button>
							{/* <div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div> */}
						</div>
					</div>
						<div className="ibsheet"id='QuaTskListDiv'></div>
						<div id="pageNavi" className="pg"></div>
					</div>
				</div> 
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;